<template>
  <div>
    <label :for="`select_${_uid}`">
      {{ label }}
      <span v-if="required" class="reqstar">*</span>
      <br />
      <p v-if="helper_text">
        <small>{{ helper_text }}</small>
      </p>
      <form-multiselect
        v-model="value"
        :multiple="multiple"
        deselect-label="Can't remove this value"
        track-by="label"
        label="label"
        :placeholder="placeholder"
        :options="compOptions"
        :searchable="false"
        :allow-empty="false"
        @input="handleValueChange"
      ></form-multiselect>
    </label>

    <p v-if="isOtherSelected">
      <label :for="`select_other_${_uid}`">
        {{ otherLabel }}
        <br />
        <input
          type="text"
          :id="`select_other_${_uid}`"
          @input="handleInputchange"
        />
      </label>
    </p>
    <p v-if="error" class="validation-error">{{ error }}</p>
  </div>
</template>

<script>
export default {
  name: "FormSelect",
  props: {
    label: {
      type: String,
      default: "Select",
    },
    helper_text: {
      type: String,
      default: "Click on the dropdown menu to see more options",
    },
    options: {
      type: String,
      default: null,
    },
    required: {
      type: [Boolean, String],
      default: false,
    },
    other: {
      type: [Boolean, String],
      default: false,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    error: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      selectedVal: null,
      isOtherSelected: false,
      value: null,
      otherLabel: "Other, please specify",
    };
  },
  methods: {
    handleValueChange(value, id) {
      if (value.value) {
        if (value.label !== this.otherLabel) {
          this.isOtherSelected = false;
          this.$emit("input", value.value);
          return;
        }
        this.isOtherSelected = true;
        return;
      }
      const otherSelected = value.filter(
        (val) => val.label === this.otherLabel
      );
      if (otherSelected.length < 1) {
        this.isOtherSelected = false;
        this.$emit("input", value.map((val) => val.value));
        return;
      }

      this.isOtherSelected = true;
    },
    handleInputchange(e) {
      const otherOption = this.value.filter(
        (opt) => opt.label === this.otherLabel
      );
      otherOption[0].value = e.target.value;
      this.$emit("input", this.value);
    },
  },
  computed: {
    placeholder() {
      return this.multiple ? "Select one or more options" : "Select one option";
    },
    compOptions() {
      const optionArray = this.options.split("\n");
      const returnArr = optionArray.map((option) => {
        const parts = option.split(":");
        return { value: parts[0], name: parts[1], label: parts[1] };
      });

      if (this.other) {
        returnArr.push({
          value: "MFT___OTHER",
          label: "Other, please specify",
          name: "Other, please specify",
        });
      }

      return returnArr;
    },
  },
};
</script>

<style scoped lang="scss">
label {
  font-size: 1.25rem;
  line-height: 1.2;
  padding-bottom: 0.5rem;
  display: inline-block;
  width: 100%;
}

.reqstar {
  color: red;
}
input {
  padding: 10px;
  width: 100%;
  @media (min-width: 768px) {
    max-width: 50vw;
  }
}
</style>
